import styled from 'styled-components';

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const MainPageContainer = styled.div`
  padding: 32px;
`;

const Style = {
  MainPageContainer,
  Heading,
};

export default Style;
